import {
  buildCidMap,
  type CidMapAttachment,
  type CidMapDocumentAssociation,
} from './email-thread-utils';

interface CidMapSource {
  attachments?: ReadonlyArray<CidMapAttachment> | null;
  documentAssociations?: ReadonlyArray<CidMapDocumentAssociation> | null;
}

/**
 * Build a cid→URL map for `EmailBodyView`. Accepts `null`/`undefined` so
 * callers with an early "loading" return can still call it unconditionally.
 * React Compiler memoizes the Map from the attachment / association arrays.
 */
export function useEmailCidMap(
  email: CidMapSource | null | undefined,
): Map<string, string> {
  return buildCidMap({
    attachments: email?.attachments,
    documentAssociations: email?.documentAssociations,
  });
}
